import { PaysafePaymentType } from '../../models/paysafe/paysafe-payment-type.enum';
import { PaysafeTokenizationOptions } from '../../models/paysafe/paysafe-tokenization-options.interface';
import { PaysafeTransactionType } from '../../models/paysafe/paysafe-transaction-type.enum';
import { mockPaysafeCustomerDetails } from './paysafe-customer-details.interface';

export const mockPaysafeTokenizationOptions: PaysafeTokenizationOptions = {
  amount: 100,
  customerDetails: mockPaysafeCustomerDetails,
  merchantRefNum: 'merchantRefNum',
  paymentType: PaysafePaymentType.Card,
  transactionType: PaysafeTransactionType.Payment,
};
